import { createSelector, createFeatureSelector } from '@ngrx/store';
import { selectAppState } from './app.selector';
import { AppState } from '../app.state';

const selectUserStore = createSelector(
    selectAppState,
    (state: AppState) => state.user
)

export const selectUserDetails = createSelector(
    selectUserStore,
    state => state.details
);

export const selectUpcomingEventBookings = createSelector(
    selectUserStore,
    state => state.details?.eventBookings?.filter(booking => new Date(booking.event.eventEnd) >= new Date()).sort((a,b) => new Date(b.event.eventStart).getDate() - new Date(a.event.eventStart).getDate())
);

export const selectPastEventBookings = createSelector(
    selectUserStore,
    state => state.details?.eventBookings?.filter(booking => new Date(booking.event.eventEnd) <= new Date()).sort((a,b) => new Date(b.event.eventStart).getDate() - new Date(a.event.eventStart).getDate())
);

export const selectEventBooking = (eventId: number) => createSelector(
    selectUserStore,
    state => state.details?.eventBookings?.find(x => x.bookingID == eventId)
)

export const selectBookingPayment = (bookingID: number) => createSelector(
    selectUserStore,
    state => state.details?.payments?.find(x => x.bookingID == bookingID)
)